import React, { useContext } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import Like from '../assests/images/like.svg'
import Dislike from '../assests/images/dislike.svg'
import Play from '../assests/images/play_icon.svg'
import Play_btn from '../assests/images/PLay_btn.svg'
import diamond from '../assests/images/diamond.svg'
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { DataContext } from '../context/DataContext';
import { useMutation } from '@tanstack/react-query';
import { likeDislike } from '../utils/Api';
import { useQueryClient } from '@tanstack/react-query';


const TopSlider = (props) => {
  const queryClient = useQueryClient();
  const { data: contextData, loading, error, refetch } = useContext(DataContext);

  const { mutate } = useMutation({
    mutationFn: async ({ user_id, contest_id, selection_type, idtoken }) => await likeDislike({ user_id, contest_id, selection_type, idtoken }),
    onSuccess: () => {
      queryClient.invalidateQueries(['allGameList']);
    },
  })

  // console.log('first', props)

  return (
    <>
      {props.type == 0 &&
        <div className='mt_10per'>
          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={'1.3'}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={true}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            {props.topgames != null &&
              props.topgames.map((data, index) => {
                return (<>
                  <SwiperSlide>
                    <div className="cardd">
                      <div className="top_c">
                        <img src={data.is_liked == '1' ? Like : Dislike} onClick={() => {
                          data?.is_liked == '1' ? mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 0, idtoken: contextData?.idtoken }) : mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 1, idtoken: contextData?.idtoken })
                        }} alt="like" />
                      </div>
                      <Link to={`/Details/${data.contest_id}`} className="cardd">
                        {/* Game Image */}
                        <img
                          src={data.app_icon_transparent}
                          alt="air_fighter"
                          className="card_img_main"
                        />
                        {/* Like/Dislike Section */}
                        {/* Game Details */}
                        <div className="btm_c">
                          <div className="displ_lr">
                            <h2 className="ttl_bg">{data.title}</h2>
                            <div className="win_daim btn_tp">
                              <img src={diamond} alt="diamond" />
                              {data.total_prize}
                            </div>
                          </div>
                          <p className="desc">
                            {/* {data.contest_description} */}
                            {data?.games_discription}
                          </p>
                        </div>
                        {/* Play Icon */}
                        <div className="playicon">
                          <img src={Play} alt="play" />
                        </div>
                      </Link>
                    </div>
                  </SwiperSlide>
                </>
                )
              })
            }

          </Swiper>
        </div>}
      {props.type == 1 &&
        <Swiper
          grabCursor={true}
          centeredSlides={false}
          slidesPerView={'1.7'}
          spaceBetween={20}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
          className="mySwiper2"
        >
          {props.trending != null &&
            props.trending.map((data, index) => {
              return (<>
                <SwiperSlide>
                  <Link to={`/Details/${data.contest_id}`} className="card2">
                    <div className="top_img_card2">
                      <img src={data.app_icon_transparent} alt="knife" className="card2_main_img" />
                      <p className="positon_trend">{index + 1}</p>
                    </div>
                    <div className="mt_5per colmn">
                      <div className="displ_lr parCon">
                        <p className="ttl_bg">{data.title}</p>
                        {/* Optional: If this needs to be clickable, move it OUTSIDE the main anchor */}
                      </div>
                      <p className="desc">{data?.contest_description}</p>
                      <div className="win_daim btn_tp ">
                        <img src={diamond} alt="diamond" />
                        {data?.total_prize}
                      </div>

                      <a href={data.game_url} class="play_now brdr_10"><img src={Play_btn} alt="play" />Play to Earn</a>
                    </div>
                  </Link>
                  <img
                    src={data.is_liked == '1' ? Like : Dislike}
                    onClick={() => {
                      data?.is_liked == '1' ? mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 0, idtoken: contextData?.idtoken }) : mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 1, idtoken: contextData?.idtoken })
                    }}
                    alt="like"
                    className="view_more_btn brdr_none imgPos"
                  />
                </SwiperSlide>
              </>
              )
            })
          }
        </Swiper>
      }

      {props.type == 2 &&
        <Swiper
          grabCursor={true}
          centeredSlides={false}
          slidesPerView={'1.7'}
          spaceBetween={20}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
          className="mySwiper3"
        >

          {props.featured != null &&
            props.featured.map((data, index) => {
              return (<>
                <SwiperSlide>
                  <Link to={`/Details/${data.contest_id}`} className="card2 card22">
                    <div className="top_img_card2">
                      <img src={data.app_icon_transparent} alt="knife" className="card2_main_img" />
                    </div>
                    <div className="mt_5per colmn">
                      <div className="displ_lr">
                        <p className="ttl_bg">{data.title}</p>
                        {/* Optional: keep this as a plain icon unless it *needs* to be clickable */}

                      </div>
                      <p className="desc">{data?.contest_description}</p>
                      <div className="win_daim btn_tp mt_5per">
                        <img src={diamond} alt="diamond" />
                        {data?.total_prize}
                      </div>
                    </div>
                    <a href={data.game_url} class="play_now brdr_10"><img src={Play_btn} alt="play" />Play to Earn</a>
                  </Link>
                  <img
                    src={data.is_liked == '1' ? Like : Dislike}
                    onClick={() => {
                      data?.is_liked == '1' ? mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 0, idtoken: contextData?.idtoken }) : mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 1, idtoken: contextData?.idtoken })
                    }}
                    alt="like"
                    className="view_more_btn brdr_none imgPos2"
                  />
                </SwiperSlide>
              </>
              )
            })
          }
        </Swiper>
      }
    </>

  )
}

export default TopSlider
